import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.768 9.10601C16.4587 8.798 15.9572 8.798 15.6478 9.10601L10.7624 13.9708L8.35216 11.5708C8.04284 11.2628 7.54132 11.2628 7.23199 11.5708C6.92267 11.8788 6.92267 12.3782 7.23199 12.6862L10.2023 15.644C10.5116 15.952 11.0131 15.952 11.3225 15.644L16.768 10.2215C17.0773 9.91343 17.0773 9.41403 16.768 9.10601Z"
      fill={fill}
    />
  </g>
);

export default Icon;
